export default {
  sm: '600px',
  md: '900px',
  lg: '1200px',

  minWidth: '350px',
  maxWidth: '1500px',
};
